export default __webpack_public_path__ + "static/char-v-61-ja-1c25c31aca32d1781fe09b3e9c553559.mp4";